export const UserJourney = {
  TourBooking: 'TourBooking',
  PriorityAccessPassBooking: 'PriorityAccessPassBooking',
  StandalonePayment: 'StandalonePayment',
};

// Map both strings and integers to the same journey constants
const userJourneyMap = {
  0: UserJourney.TourBooking,
  1: UserJourney.PriorityAccessPassBooking,
  2: UserJourney.StandalonePayment,
  TourBooking: UserJourney.TourBooking,
  PriorityAccessPassBooking: UserJourney.PriorityAccessPassBooking,
  StandalonePayment: UserJourney.StandalonePayment,
};

/**
 * Resolves a user journey input to either the string or numeric version of
 * user journey that may come from backend.
 * @param {string|number} input - Input that might be a number or string identifier.
 * @returns {string} - The resolved user journey constant.
 */
export function getUserJourney(input) {
  return userJourneyMap[String(input)] || 'Unknown';
}
